import React, { FC } from 'react'
import _ from 'lodash'
import { MultipleRow_s, SingleRow_s } from 'components/table/hovers/hover-styles'

import { localizeNum, isValidNumber } from "data/lib/numbers"
import { formatDate, isValidDate } from 'data/lib/dates'

import { Label_s } from 'styles/app-styles'

type DetailedHoverProps = {
  config: {},
  data: [],
  field: string,
  inflationData: object[],
  lineItemData: object[],
  areaMeasuresData: object[],
  namedRecoveriesData: object[],
  reportTagsData: object[],
  rentRollData: object[],
  systemLineItemData: object[],
  tenantGroupsData: object[],
  payoutData: object[],
  usersData: object[],
  portfolioData: object[],
  stateName: string,
  items: []
}

const DetailedHover: FC<DetailedHoverProps> = (props) => {
  let items: object[] = props.items || [];

  let state = props.stateName;
  if (props.field === 'tenantgroupdetail') state = 'detailed'
  if (props.field === 'users'){
    state = 'detailed'
    items = props.data['users']
  }
  if (props.field === 'defaultportfolios'){
    state = 'detailed'
    items = props.data['defaultportfolios']
  }

  if (props.field === 'approles'){
    state = 'detailed'
    items = props.data['approles']
  }

  if(state === "percentTenantRevenue") {
    let rentRollData = _.sortBy(props.rentRollData, "sortorder")
    items = _.sortBy(items, (item) => {
      return _.findIndex(rentRollData, (rr) => rr.rentrollid === item.rentRollId)
    })
  }

  let count = items.length;
  if (count > 3) items = items.slice(0, 3);

  return (
    <div>
      <SingleRow_s>
        { props.config[state]?.single && props.config[state].single.map(c => {
          const label:string|null = c.label || null
          let   val:any|null      = null

          if (Array.isArray(c.key)){
            for (let i of c.key){
              val = val ? val[i] : props.data[i]
            }
          } else val = props.data[c.key]

          // If named item, show code
          if (c.key[c.key.length - 1] === 'inflationNamedItemId' && val){
            val = _.get(_.find(props.inflationData, { inflationid: val }), "code");
          }
          if (c.key === 'lineItemId' && val){
            val = _.find(props.lineItemData, { lineitemid: val });
            val = val ? val.code : ""
          }
          if (c.key[c.key.length - 1] === 'payoutNamedItemId' && val){
            val = _.get(_.find(props.payoutData, { payoutid: val }), "code")
          }
          if (c.key[c.key.length - 1] === 'reportTagNamedItemId' && val){
            val = _.get(_.find(props.reportTagsData, { reporttagid: val }), "code")
          }
          // If boolean, show 'yes' for checked
          if (val && typeof val === 'boolean'){
            val === true ? val = 'Yes' : val = 'No'
          }
          // If date, show MM/YYYY date
          if (isValidDate(val)){
            val = formatDate(val, 'MM/YYYY');
          }
          // If number, show 4 digits of precision
          if (isValidNumber(val)){
            val =`${localizeNum(val, 4)}`
          }

          return (
            <div>
              <Label_s>{ label }</Label_s>
              { val && <span>{val}</span> }
            </div>
          )
        })}
      </SingleRow_s>
      { props.config[state].list &&
        <SingleRow_s>
          <div>
            <Label_s>{props.config[state].list.label}</Label_s>
            <ul style={{listStyle: 'inside'}}>
              { items && items.map(item => {
                let val = item[props.config[state].list.key];
                if (props.config[state].list.key === 'tenantGroupId'){
                  val = _.find(props.tenantGroupsData, { tenantgroupid: val });
                  val = val ? val.code : ""
                }
                if (props.config[state].list.key === 'recoveryNamedItemId'){
                  val = _.find(props.namedRecoveriesData, { recoveryid: val });
                  val = val ? `${val.code} - ${val.name}` : ""
                }
                if (props.config[state].list.key === 'rentRollId'){
                  val = _.find(props.rentRollData, { rentrollid: val });
                  val = val ? `${val.sortorder} - ${val.suite}: ${val.tenant}` : ""
                }
                if (props.config[state].list.key === 'users'){
                  val = _.find(props.usersData, { userid: item })
                  val = val ? `${val.name}` : ""
                }
                if (props.config[state].list.key === 'defaultportfolios'){
                  val = _.find(props.portfolioData, { portfolioid: item })
                  val = val ? `${val.code}` : ""
                }
                if (props.config[state].list.key === 'approles'){
                  val = item || ""
                }
                return <li>{val}</li>
              })}
            </ul>
          </div>
        </SingleRow_s>
      }
      <MultipleRow_s>
        <table>
          <thead>
            { props.config[state].multiple && props.config[state].multiple.map(c => {
              return (
                <th>
                  <Label_s>{ c.label }</Label_s>
                </th>
              )
            })}
          </thead>
          { props.config[state].multiple && items.map(item => {
            return (
              <tr>
                { props.config[state].multiple.map(c => {
                  let val:any|null = null
                  if (Array.isArray(c.key)){
                    for (let i of c.key){
                      val = val ? val[i] : item[i]
                    }
                  } else val = item[c.key]
                  // If date, show MM/YYYY date
                  if (isValidDate(val)){
                    val = formatDate(val, 'MM/YYYY');
                  }
                  // If named item, show code
                  if (c.key[c.key.length - 1] === 'areaMeasureNamedItemId' && val){
                    val = _.find(props.areaMeasuresData, { areaid: val });
                    val = val ? val.code : ""
                  }
                  if (c.key === 'lineItemId' && val){
                    val = _.find(props.lineItemData, { lineitemid: val }) || _.find(props.systemLineItemData, { systemlineitemid: val});
                    val = val ? val.code : ""
                  }
                  if (c.key === 'rentRollId' && val){
                    val = _.find(props.rentRollData, { rentrollid: val })
                    val = val ? `${val.sortorder} - ${val.suite}: ${val.tenant}` : ""
                  }
                  // If number, show 4 digits of precision
                  if (isValidNumber(val)){
                    val =`${localizeNum(val, 4)}`
                  }
                  // If boolean, display textual representation of value
                  if(_.isBoolean(val)){
                    if(val) val = "True"
                    else val = "False"
                  }

                  return (
                    <td>
                      { val && <span>{val}</span> }
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </table>
        { count > 3 && <div style={{marginLeft: 'auto', textAlign: 'right'}}><strong>...</strong></div>}
      </MultipleRow_s>
    </div>
  )
}

export default DetailedHover